import { Component, inject, input, model, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../../core/service/base/his-ui.service';
/** Komponente zum Anzeigen von Hilfetexten.
 * Bestehend aus einem Button und einem Content-Bereich, die je nach Zustand unterschiedliche Titel, Untertitel und Inhalte anzeigen können, die über die Inputs gesteuert werden.
 * Für eine aufteilte Nutzung können die einzelnen Komponenten HisHelptextButtonComponent und HisHelptextContentComponent verwendet werden, siehe Beispiel in der HisPanelHelptextDirective.
 */
@Component( {
    selector: 'his-helptext',
    templateUrl: './his-helptext.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisHelptextComponent {
    private readonly hisUiService = inject( HisUiService );
    private readonly defaultHelpTitle = this.hisUiService.translate( 'common.help' );

    /** Hover-Titel des Buttons im geschlossenen Zustand. */
    readonly title = input( this.defaultHelpTitle, { transform: ( v: string ) => v ?? this.defaultHelpTitle } );
    /** Sichtbarer Text neben dem Icon im geschlossenen Zustand. Wird kein Wert übergeben, erscheint der Standardtext. */
    readonly linkTitle = input( this.defaultHelpTitle, { transform: ( v: string ) => v ?? this.defaultHelpTitle } );
    /** Hover-Titel des Buttons im geöffneten Zustand. Fällt auf {@link HisHelptextComponent.title} zurück, wenn nicht gesetzt. */
    readonly closingTitle = input<string>();
    /** Sichtbarer Text neben dem Icon im geöffneten Zustand. Fällt auf {@link HisHelptextComponent.linkTitle} zurück, wenn nicht gesetzt. */
    readonly closingLinkTitle = input<string>();

    /** Überschrift des Hilfetextes: Hilfe für 'subtitle' */
    readonly subtitle = input( '' );
    /** Inhalt des Hilfetextes. */
    readonly helptext = input( '' );
    /** Gibt an, ob der Hilfetext angezeigt wird. */
    readonly displayHelptext = model( false );

    /** Wechselt den Zustand des Hilfetextes zwischen angezeigt und verborgen. */
    public toggleShowHelptext() {
        this.displayHelptext.update( val => !val );
    }
}
